@if (state.hasPendingDrafts()) {
	<section class="drafts-panel">
		<header class="drafts-header">
			<mat-icon class="drafts-header-icon"><i class="fa-solid fa-triangle-exclamation"></i></mat-icon>
			<div class="drafts-header-text">
				<strong>Zmiany w systemach zewnętrznych po rozliczeniu</strong>
				@if (state.isSettled()) {
					<span>
						Miesiąc jest rozliczony — poniższe dane nie zostały zastosowane. Aby je zastosować, cofnij
						rozliczenie i pobierz dane ponownie.
					</span>
				} @else {
					<span>
						Miesiąc jest odblokowany — poniższe zmiany wciąż czekają. Zaakceptuj je, aby zapisać, albo
						odrzuć.
					</span>
				}
			</div>
			@if (state.draftsLoading()) {
				<mat-spinner diameter="18"></mat-spinner>
			}
		</header>

		@if (state.draftsError()) {
			<p class="drafts-error">{{ state.draftsError() }}</p>
		}

		@if (state.pendingNettoDrafts().length > 0) {
			<div class="drafts-group">
				<h4 class="drafts-group-title">Kwoty netto</h4>
				@for (row of state.pendingNettoDrafts(); track row.id) {
					<div class="draft-row">
						<div class="draft-row-body">
							<span class="draft-row-title">{{ row.label }}</span>
							<span class="draft-row-detail">
								@if (row.currentNetto !== null) {
									Rozliczono {{ row.currentNetto | priceFormat }} zł → nowa wartość
									{{ row.proposedNetto | priceFormat }} zł
									@if (row.diff !== null) {
										<span
											class="draft-diff"
											[class.draft-diff-positive]="row.diff > 0"
											[class.draft-diff-negative]="row.diff < 0"
										>
											({{ row.diff > 0 ? '+' : '' }}{{ row.diff | priceFormat }} zł)
										</span>
									}
								} @else {
									Brak zapisanej kwoty → nowa wartość {{ row.proposedNetto | priceFormat }} zł
								}
							</span>
						</div>
						@if (!state.isSettled()) {
							<button
								mat-flat-button
								color="primary"
								class="draft-accept"
								[disabled]="state.draftActionBusy()"
								[matTooltip]="acceptTooltip"
								(click)="state.acceptDraft(row.id)"
							>
								@if (state.draftAcceptingId() === row.id) {
									<mat-spinner diameter="14"></mat-spinner>
								} @else {
									<mat-icon><i class="fa-solid fa-check"></i></mat-icon>
								}
								Zaakceptuj
							</button>
						}
						<button
							mat-stroked-button
							class="draft-reject"
							[disabled]="state.draftActionBusy()"
							[matTooltip]="rejectTooltip"
							(click)="state.rejectDraft(row.id)"
						>
							@if (state.draftRejectingId() === row.id) {
								<mat-spinner diameter="14"></mat-spinner>
							} @else {
								<mat-icon><i class="fa-solid fa-xmark"></i></mat-icon>
							}
							Odrzuć
						</button>
					</div>
				}
			</div>
		}

		@if (state.pendingEventDrafts().length > 0) {
			<div class="drafts-group">
				<div class="drafts-group-head">
					<h4 class="drafts-group-title">Nawigator — zmiany w wydarzeniach</h4>
					@if (!state.isSettled()) {
						<button
							mat-flat-button
							color="primary"
							class="draft-accept"
							[disabled]="state.nawigatorDisabled() || state.draftActionBusy()"
							[matTooltip]="state.nawigatorTooltip() || pullApplyTooltip"
							(click)="state.loadNawigator()"
						>
							@if (state.nawigatorLoading()) {
								<mat-spinner diameter="14"></mat-spinner>
							} @else {
								<mat-icon><i class="fa-solid fa-check"></i></mat-icon>
							}
							Zaakceptuj — pobierz z Nawigatora
						</button>
					}
				</div>
				@for (row of state.pendingEventDrafts(); track row.id) {
					<div class="draft-row">
						<div class="draft-row-body">
							<span class="draft-row-title">
								@if (row.currentSymbol) {
									{{ row.currentSymbol }}
									<mat-icon class="draft-row-arrow"><i class="fa-solid fa-arrow-right"></i></mat-icon>
								}
								{{ row.symbol }}
								<span class="draft-row-badge" [class]="'draft-row-badge--' + row.changeType">
									@switch (row.changeType) {
										@case ('changed') {
											zmiana
										}
										@case ('removed') {
											usunięte w Nawigatorze
										}
										@default {
											nowe
										}
									}
								</span>
							</span>
							<span class="draft-row-detail">
								@if (row.changeType === 'changed' && row.currentDateTo) {
									{{ row.currentDateFrom }} — {{ row.currentDateTo }}
									<mat-icon class="draft-row-arrow"><i class="fa-solid fa-arrow-right"></i></mat-icon>
									<strong>{{ row.dateFrom }} — {{ row.dateTo }}</strong>
								} @else if (row.changeType === 'removed') {
									<s>{{ row.dateFrom }} — {{ row.dateTo }}</s>
								} @else {
									{{ row.dateFrom }} — {{ row.dateTo }}
								}
								@if (row.person) {
									· {{ row.person }}
								}
							</span>
						</div>
						<button
							mat-stroked-button
							class="draft-reject"
							[disabled]="state.draftActionBusy()"
							[matTooltip]="rejectTooltip"
							(click)="state.rejectDraft(row.id)"
						>
							@if (state.draftRejectingId() === row.id) {
								<mat-spinner diameter="14"></mat-spinner>
							} @else {
								<mat-icon><i class="fa-solid fa-xmark"></i></mat-icon>
							}
							Odrzuć
						</button>
					</div>
				}
			</div>
		}

		@if (state.pendingBonusDrafts().length > 0) {
			<div class="drafts-group">
				<div class="drafts-group-head">
					<h4 class="drafts-group-title">Dodatki / potrącenia NavBridge</h4>
					@if (!state.isSettled()) {
						<button
							mat-flat-button
							color="primary"
							class="draft-accept"
							[disabled]="state.navbridgeBonusesDisabled() || state.draftActionBusy()"
							[matTooltip]="state.navbridgeBonusesTooltip() || pullApplyTooltip"
							(click)="state.loadNavbridgeBonuses()"
						>
							@if (state.navbridgeBonusesLoading()) {
								<mat-spinner diameter="14"></mat-spinner>
							} @else {
								<mat-icon><i class="fa-solid fa-check"></i></mat-icon>
							}
							Zaakceptuj — pobierz z NavBridge
						</button>
					}
				</div>
				@for (row of state.pendingBonusDrafts(); track row.id) {
					<div class="draft-row">
						<div class="draft-row-body">
							<span class="draft-row-title">{{ row.name }}</span>
							@if (row.currentValueGrosze !== null) {
								<span class="draft-row-detail"
									>{{ row.currentDate }} · {{ row.currentValueGrosze | priceFormat }} zł
									<mat-icon class="draft-row-arrow"><i class="fa-solid fa-arrow-right"></i></mat-icon>
									{{ row.date }} · {{ row.valueGrosze | priceFormat }} zł</span
								>
							} @else {
								<span class="draft-row-detail"
									>{{ row.date }} · {{ row.valueGrosze | priceFormat }} zł</span
								>
							}
						</div>
						<button
							mat-stroked-button
							class="draft-reject"
							[disabled]="state.draftActionBusy()"
							[matTooltip]="rejectTooltip"
							(click)="state.rejectDraft(row.id)"
						>
							@if (state.draftRejectingId() === row.id) {
								<mat-spinner diameter="14"></mat-spinner>
							} @else {
								<mat-icon><i class="fa-solid fa-xmark"></i></mat-icon>
							}
							Odrzuć
						</button>
					</div>
				}
			</div>
		}
	</section>
}
